import React, { useState, useEffect } from 'react';

interface CountdownModalProps {
  isOpen: boolean;
  onComplete: () => void;
  startCount?: number;
}

const CountdownModal: React.FC<CountdownModalProps> = ({
  isOpen,
  onComplete,
  startCount = 3
}) => {
  const [count, setCount] = useState(startCount);

  useEffect(() => {
    if (!isOpen) {
      setCount(startCount);
      return;
    }

    if (count > 0) {
      const timer = setTimeout(() => {
        setCount(count - 1);
      }, 1000);
      return () => clearTimeout(timer);
    } else {
      // Countdown finished
      const completeTimer = setTimeout(() => {
        onComplete();
      }, 500); // Small delay before completing
      return () => clearTimeout(completeTimer);
    }
  }, [count, isOpen, onComplete, startCount]);

  if (!isOpen) return null;

  return (
    <div className="countdown-modal-overlay">
      <div className="countdown-modal-content">
        <div className="countdown-header">
          <h2 className="countdown-title">Get Ready!</h2>
          <p className="countdown-subtitle">Your trivia challenge begins in...</p>
        </div>

        <div className="countdown-display">
          {count > 0 ? (
            <div className="countdown-number" key={count}>
              {count}
            </div>
          ) : (
            <div className="countdown-go">
              GO!
            </div>
          )}
        </div>

        <div className="countdown-footer">
          <div className="countdown-pulse-ring"></div>
        </div>
      </div>
    </div>
  );
};

export default CountdownModal;
